/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pesticide_EditInputs */

const vi_pesticide_edit = /** @type {(inputs: Pesticide_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa thuốc`)
};

/**

* @param {Pesticide_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pesticide_edit = /** @type {((inputs?: Pesticide_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pesticide_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pesticide_edit(inputs)
});